export default __webpack_public_path__ + "static/media/circle-arrow-down.3128a66a.svg";